import React,{useEffect, useState, useContext} from 'react'
import { ORDER_SALE_TYPE_LIST_DYNAMIC,ORDER_STATUS_DYNAMIC,ORDER_PAYMENT_TYPE_LIST } from '../../../../utils/configs';
import { formatDateByTimezone} from "../../../../utils/commonFunctions";
import CustomSelect from "../../../../common/CustomSelect";
import moment from 'moment';
import { TbReload } from "react-icons/tb";
import { IoArrowForwardOutline } from "react-icons/io5";
import deleteIcon from '../../../../assets/icons/delete.svg';
import editIcon from "../../../../assets/edit.svg";
import { useTranslation } from "react-i18next";
import {ThemeContext} from '../../../../contexts/themeContext';


const OrderListing=(props)=> {
    const {dataOrder,inventoryDetails}=props;
    const {ready } = useTranslation();
    const [collapsedRows, setCollapsedRows] = useState(null);
    const [orderLists, setOrderLists] = useState({});
    const {themedColor} = useContext(ThemeContext);

    const toggleCollapse = (rowId) => {
      setCollapsedRows(prevIndex => (prevIndex === rowId ? null : rowId));
    }
useEffect(() => {
  if(dataOrder){
    setOrderLists(dataOrder)
  }
}, [dataOrder])

const getOrderItems=(item)=>{
    const res=  item.map((it,index)=>
   <div key ={index} className='justifyContentSpaceBetween margBottom10 flexRow width100'>
    <div style={{width:'80%'}}className='justifyContentFlexStart'>{it.itemName}&nbsp;{it?.sourceSeat?.seatNumber && it?.targetSeat?.seatNumber ? `(${it.sourceSeat.seatNumber} -> ${it.targetSeat.seatNumber})` : ""}
<span className='margLeft10'>{it.quantity} x {it.itemPrice}</span></div>
    <div className='flexRow'>{it.totalAmountInUsedCurrency}</div>
    </div>
     )
      return res;
}
const onStatusChange=(e)=>{
e?props.setStatus(e.value):props.setStatus("")
}
const onSaleTypeChange=(e)=>{
  e?props.setSaleType(e.value):props.setSaleType("")


}
const onPaymentTypeChange=(e)=>{
  e?props.setPaymentType(e.value):props.setPaymentType("")

}
const onSearch=(e)=>{
    props.setSearchKeyOrders(e.target.value)
}
function getQuantitySum(arr) {
  if (arr && arr.length) {
    const resp = arr.reduce((acc, item) => {
      return acc + (item.quantity || 0);
    }, 0);
    return resp;
  } else {
    return 0;
  }
}

  return (
    <>
    <div className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark">
    {
            <>
  <div className='fitcontent justifyContentSpaceBetween display wrapper-sector-dynamic'>
              <div className='flexRow sector-banner justifyContentSpaceBetween'>
                <div className='flexRow justifyContentFlexStart'>
                   <div className='sector-number fontMedium'>{dataOrder?.label?.flightNumber??orderLists?.flightDetails?.flightNumber}</div>
                   <div className='flexCol justifyContentCenter alignItemsCenter'>
                <div className='flexRow sector-tag'>{dataOrder?.label?.origin??orderLists?.flightDetails?.origin}</div>
                <div className='flexRow fontMedium'>{dataOrder?.label?.originName??orderLists?.flightDetails?.originName}</div>
                </div>
                </div>

                <div className='flexCol justifyContentCenter alignItemsCenter'>
                <div className='flexRow'> <IoArrowForwardOutline size={17} color={'#F06548'}/></div>
                <div className='flexRow fontMedium'>{moment.parseZone(formatDateByTimezone(dataOrder?.label?.flightDate?dataOrder?.label?.flightDate:orderLists?.flightDetails?.flightDate)).format('DD-MM-YYYY')}</div>
                </div>
               <div className='flexCol justifyContentCenter alignItemsCenter'>
                <div className='flexRow sector-tag'>{dataOrder?.label?.destination??orderLists?.flightDetails?.destination}</div>
                <div className='flexRow fontMedium'>{dataOrder?.label?.destinationName??orderLists?.flightDetails?.destinationName}</div>
                </div>
              </div>
              </div>
                <div className='flexRow width100 margBot10 margTop8 justifyContentSpaceBetween alignItemsCenter tableFilterBlocks'>
                    <div className="flexRow justifyContentFlexStart alignItemsCenter leftBlock">
                        <div className="flexRow justifyContentFlexEnd alignItemsBaseline">
                              <button className='saleType-div m-2'>
                              <CustomSelect
                              options={ORDER_STATUS_DYNAMIC}
                              width={'13rem'}
                              placeHolder={'Order Status'}
                              onChange={onStatusChange}
                              />
                              </button>

                        <button className='saleType-div m-2'>
                              <CustomSelect
                              options={ORDER_SALE_TYPE_LIST_DYNAMIC}
                              width={'13rem'}
                              placeHolder={'Sale Type'}
                              onChange={onSaleTypeChange}
                              />
                              </button>

                            <button className='saleType-div m-2'>
                              <CustomSelect
                              options={ORDER_PAYMENT_TYPE_LIST}
                              width={'13rem'}
                              placeHolder={'Payment Type'}
                              onChange={onPaymentTypeChange}
                              />
                              </button>

                        </div>
                    </div>
                    <div className="flexRow justifyContentFlexEnd alignItemsCenter rightBlock">
                        <div className="underline margRight10">
                            <span><input className="search-layout" onChange={onSearch} value={props.searchKeyOrders} type="search" placeholder="Search Order no / seat no" /></span>
                        </div>




                    </div>
                </div>
                <div className='table-header'></div>

                <table style={{borderRadius:'5px'}}>
      <thead style={{backgroundColor:'#0f172a'}}>
        <tr  className='sticky'>
          <th>Order No</th>
          <th style={{width:"15%"}}>Seat No</th>
          <th>Sale Type</th>
          <th style={{ whiteSpace: 'nowrap' }}>Pay Mode Status</th>
         <th> Status</th>
          <th>Total</th>

        </tr>
      </thead>
     {orderLists?.data && orderLists.data?.length? <tbody>
        {orderLists?.data.map((row, index) => (
          <React.Fragment key={index}>
            <tr className='pointer' style={{ backgroundColor: collapsedRows === index ? themedColor.hover : '' }} onClick={() => toggleCollapse(index)}>
              <td style={{ whiteSpace: 'nowrap' }}>{row.orderNo}</td>
              <td>{row.customerInfo?.seatNumber}</td>
              <td style={{ whiteSpace: 'nowrap' }}>{ORDER_SALE_TYPE_LIST_DYNAMIC.find(ord=>ord.value===row.saleType)?.label}</td>
              <td style={{ whiteSpace: 'nowrap' }}>{row.paymentType==='none'?"SSR":row.paymentType.charAt(0).toUpperCase()+row.paymentType.slice(1)}</td>
              <td style={{ whiteSpace: 'nowrap' }}>{row.status.charAt(0).toUpperCase()+row.status.slice(1)==='Accepted'?<span className='status-consolidate margLeft00' style={{backgroundColor:'#47d26c'}}>{row.status.charAt(0).toUpperCase()+row.status.slice(1)}</span>:<span className='status-consolidate margLeft00' style={{backgroundColor:'#f03630'}}>{row.status.charAt(0).toUpperCase()+row.status.slice(1)}</span>}</td>
              <td style={{ whiteSpace: 'nowrap' }}>{`${row.currencyInfo?.currencyCode} ${row.totalAmountInUsedCurrency} (${getQuantitySum(row.items)}) ${getQuantitySum(row.items)!==1?"Items":'Item'}`}</td>

            </tr>
            {collapsedRows===index && (
              <tr>
                <td style={{backgroundColor:themedColor.hover}} colSpan="6">
            <div className='width100 justifyContentSpaceBetween display'>
{row.status==='accepted'&& dataOrder.action === "ordersEditDoc" && dataOrder?.state!=='committed' && <div className='flexRow justifyContentFlexStart'>
            <span onClick={()=>inventoryDetails(row,null,'editOrder',null,null)} className='status-consolidate-orders' style={{marginLeft:0,backgroundColor:'#03A5FC'}}><img  className="icon-size" style={{margin:'4px'}} alt='uploadItem' src={editIcon} />Edit Order</span>
            <span  onClick={()=>inventoryDetails(row,null,"cancelOrder",null,null)} className='status-consolidate-orders' style={{backgroundColor:'#F03630'}}><img  className="icon-size" style={{margin:'4px'}} alt='uploadItem' src={deleteIcon} />Cancel Order</span>

</div>}
{row.status==='cancelled'&& row.editDocumentId &&<div className='flexRow justifyContentFlexStart'>
            <span  onClick={()=>inventoryDetails(row,null,"undoCancelOrder",null,null)} className='status-consolidate-orders' style={{backgroundColor:'#4c5c81',padding:'10px',marginLeft:0}}><TbReload/> &nbsp;Undo Cancel Order</span>

</div>}
              <div className='flexRow'>
                  <div style={{float:'left'}} className="margTop10 flexCol width50 justifyContentFlexStart">
                <div className='margBottom10'>
                  <label className='fontExtrabold'>Date & Time</label>
                  <div>{moment(row.timestamp).tz(dataOrder?.timeZone).format('DD-MM-YYYY hh:mm A')}</div>
                </div>

                <div className='margBottom10'>
                  <label className='fontExtrabold'>Taken By</label>
                  <div className='flexCol'>
                  <div className='flexRow'>
                  {row.createdBy.employeeName}
                    </div>
                    <div className='flexRow'>
                    {row.createdBy.employeeCode}
                    </div>
                    </div>
                </div>
                <div className='margBottom10'>
                  <label className='fontExtrabold'>Ordered Using</label>
                  <div className='flexCol'>
                  <div className='flexRow'>
                  {row.userAgent.appName}@ {row.userAgent.appVersion}
                    </div>
                    <div className='flexRow'>
                    {row.userAgent.deviceModel}, {row.userAgent.macId?`MAC ID: ${row.userAgent.macId}`:row.userAgent.deviceName}

                    </div>
                    </div>
                </div>
                <div className='margBottom10'>
                  <label className='fontExtrabold'>Customer Info</label>
                  <div className='flexCol'>
                  <div className='flexRow'>
                  {row.customerInfo.customerName}
                    </div>
                    <div className='flexRow'>
                    Seat No: {row.customerInfo.seatNumber}
                    </div>
                    <div className='flexRow'>
                    PNR: {row.customerInfo.pnr}
                    </div>
                    </div>
                </div>


              </div>


              <div  className="margTop10 flexCol width50">

                <div className='flexCol margBottom10 justifyContentSpaceBetween'>
                  <label className='fontExtrabold'>Items</label>
                { getOrderItems(row.items)}
                <div className='flexCol justifyContentFlexEnd'>
                    <div className='flexRow justifyContentFlexEnd margBottom10'>
                    Gross&nbsp; <span className='fontExtrabold'>{row.currencyInfo?.currencyCode} {row.netAmountInUsedCurrency}</span>
                    </div>
                    <div className='flexRow justifyContentFlexEnd margBottom10'>
                     GST&nbsp;<span className='fontExtrabold'>{row.currencyInfo?.currencyCode} {row.gstAmountInUsedCurrency}</span> 
                    </div>
                    <div className='flexRow justifyContentFlexEnd margBottom10'>
                    Grand Total &nbsp;<span className='fontExtrabold'>{row.currencyInfo?.currencyCode} {row.totalAmountInUsedCurrency}</span>
                    </div>

                </div>

                </div>

              </div>


              </div>
            </div>

                </td>
              </tr>
            )}
          </React.Fragment>
        ))}
      </tbody>:
      <tr>
      <td colSpan="6">
      <div className='flexRow w-100 h-100 justifyContentCenter alignItemsCenter'>No Data</div>
      </td>
      </tr>
      }
    </table>
            </>
        }

        {
          !ready &&<div className='overlay_hide sub'></div>
        }
    </div>
</>
  )
}

export default OrderListing;